/* ---- Existing state ---- */
const clipboard = document.getElementById('clipboard');
const canvas = document.getElementById('draw-canvas');
const ctx = canvas.getContext('2d');
const eraserCursor = document.getElementById('eraser-cursor');
const eraserSlider = document.getElementById('eraser-size');
let eraserSize = Number(eraserSlider.value);
eraserSlider.addEventListener('click', (e) => {
  e.stopPropagation();
});
const ball = document.getElementById('ball');
const trash = document.getElementById('trash');
const recordBtn = document.getElementById('record');

canvas.width = clipboard.clientWidth;
canvas.height = clipboard.clientHeight;

function centerBall() {
  const ballRadius = ball.offsetWidth / 2;

  const left = (clipboard.clientWidth / 2) - ballRadius;
  const top = (clipboard.clientHeight / 2) - ballRadius;

  ball.style.left = left + 'px';
  ball.style.top = top + 'px';
}

centerBall();

let currentTool = null;
let currentColor = '#007aff';
let drawing = false;
let paths = [];
let currentPath = null;
let snapMode = false;          // Is snap mode active
let snappedPiece = null;       // Which piece the ball is snapped to
let ballLocked = false;
const snapOffset = { x: -5, y: -10 }; // Ball sits 30px above the piece
const snapMessage = document.getElementById('snap-message');

/* ---- Pass / Shoot ---- */
const passBtn = document.getElementById('pass-ball');
const shootBtn = document.getElementById('shoot-ball');

const BALL_RADIUS = ball.offsetWidth / 2;
const HOOP_VISUAL_OFFSET_X = 1; // very small, visual-only correction

const HOOP_TARGET = {
  x: (clipboard.clientWidth / 2) - BALL_RADIUS + HOOP_VISUAL_OFFSET_X,
  y: 34
};

let history = [];

let isRecording = false;
let recorded = [];
let recordedPiecesSnapshot = [];
let isPlayingBack = false;
let playbackIndex = 0;
let playbackToken = 0;

eraserSlider.addEventListener('input', () => {
  eraserSize = Number(eraserSlider.value);

  // keep cursor in sync immediately
  eraserCursor.style.width = eraserSize + 'px';
  eraserCursor.style.height = eraserSize + 'px';
});

/* ---- Active tool ---- */
const toolButtons = document.querySelectorAll('#toolbar button');

function hideEraser() {
  eraserCursor.style.display = 'none';
}

function setPiecesPointerEvents(enabled) {
  document.querySelectorAll('.piece').forEach(piece => {
    piece.style.pointerEvents = enabled ? 'auto' : 'none';
  });

  // ALSO disable ball interaction while erasing
  if (ball) {
    ball.style.pointerEvents = enabled ? 'auto' : 'none';
  }
}

function setActiveTool(btn, toolName = null) {
  // If clicking the same active tool → turn everything off
  if (btn && btn.classList.contains('active')) {
    toolButtons.forEach(b => b.classList.remove('active'));
    currentTool = null;
    hideEraser();
    setPiecesPointerEvents(true); // re-enable pieces
    return;
  }

  // Otherwise activate selected tool
  toolButtons.forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');

  currentTool = toolName;
  hideEraser();

  // 🔥 THIS IS THE IMPORTANT PART
  if (toolName === 'erase') {
    setPiecesPointerEvents(false); // disable piece interaction
  } else {
    setPiecesPointerEvents(true); // normal behavior
  }
}

/* ---- Ball Animation Helper ---- */
function animateBallMove(from, to, onComplete) {
  const steps = 20;
  let step = 0;

  const dx = (to.x - from.x) / steps;
  const dy = (to.y - from.y) / steps;

  function animate() {
    if (step >= steps) {
      ball.style.left = to.x + 'px';
      ball.style.top = to.y + 'px';
      if (onComplete) onComplete();
      return;
    }

    ball.style.left = (from.x + dx * step) + 'px';
    ball.style.top = (from.y + dy * step) + 'px';

    step++;
    setTimeout(animate, 30);
  }

  animate();
}

/* ---- Helpers ---- */
function getCanvasPos(e) {
  const r = canvas.getBoundingClientRect();
  return { x: e.clientX - r.left, y: e.clientY - r.top };
}

function getClipboardPos(e) {
  const r = clipboard.getBoundingClientRect();
  return { x: e.clientX - r.left, y: e.clientY - r.top };
}

function redraw() {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  paths.forEach(p => {
    ctx.strokeStyle = p.color;
    ctx.lineWidth = p.size;
    ctx.globalCompositeOperation = p.erase ? 'destination-out' : 'source-over';
    ctx.beginPath();
    p.points.forEach((pt, i) => i ? ctx.lineTo(pt.x, pt.y) : ctx.moveTo(pt.x, pt.y));
    ctx.stroke();
  });
  ctx.globalCompositeOperation = 'source-over';
}

/* ---- Drawing ---- */
canvas.addEventListener('mousedown', e => {
  if (!currentTool) return;

if (currentTool === 'draw' || currentTool === 'erase') {
    drawing = true;
    currentPath = {
      color: currentColor,
      size: currentTool === 'erase' ? eraserSize : 3,
      erase: currentTool === 'erase',
      points: [getCanvasPos(e)]
    };
    paths.push(currentPath);
    history.push({ type: 'draw' });
  }
});

canvas.addEventListener('mousemove', e => {
  const pos = getClipboardPos(e);

  if (currentTool === 'erase') {
  eraserCursor.style.display = 'block';
  eraserCursor.style.left = pos.x + 'px';
  eraserCursor.style.top = pos.y + 'px';
  eraserCursor.style.width = eraserSize + 'px';
  eraserCursor.style.height = eraserSize + 'px';
}

  if (!drawing || !currentPath) return;
  currentPath.points.push(getCanvasPos(e));
  redraw();
});

// --- TOUCH SUPPORT FOR DRAWING/ERASING ---
canvas.addEventListener('touchstart', e => {
  e.preventDefault();
  const touch = e.touches[0];
  if (!currentTool) return;

  if (currentTool === 'draw' || currentTool === 'erase') {
    drawing = true;
    currentPath = {
      color: currentColor,
      size: currentTool === 'erase' ? eraserSize : 3,
      erase: currentTool === 'erase',
      points: [getCanvasPos(touch)]
    };
    paths.push(currentPath);
    history.push({ type: 'draw' });
  }
});

canvas.addEventListener('touchmove', e => {
  e.preventDefault();
  if (!drawing || !currentPath) return;
  const touch = e.touches[0];
  currentPath.points.push(getCanvasPos(touch));
  redraw();
});

canvas.addEventListener('touchend', e => {
  if (drawing && currentPath && isRecording) {
    recorded.push({
      type: 'stroke',
      path: {
        color: currentPath.color,
        size: currentPath.size,
        erase: currentPath.erase,
        points: currentPath.points.map(p => ({ x: p.x, y: p.y }))
      }
    });
  }
  drawing = false;
});

document.addEventListener('mouseup', () => {
  if (drawing && currentPath && isRecording) {
    recorded.push({
      type: 'stroke',
      path: {
        color: currentPath.color,
        size: currentPath.size,
        erase: currentPath.erase,
        points: currentPath.points.map(p => ({ x: p.x, y: p.y }))
      }
    });

  }
  drawing = false;
});

/* ---- Tools ---- */
document.getElementById('blue-pen').onclick = function () {
  currentColor = '#007aff';
  setActiveTool(this, 'draw');
};
document.getElementById('red-pen').onclick = function () {
  currentColor = '#ff3b30';
  setActiveTool(this, 'draw');
};
document.getElementById('eraser').onclick = function () {
  setActiveTool(this, 'erase');
};

/* ---- Undo ---- */
document.getElementById('undo').onclick = function () {
  const last = history.pop();
  if (!last) return;

  if (last.type === 'draw') {
    paths.pop();
    redraw();
  }

  if (last.type === 'move') {
    last.el.style.left = last.from.x + 'px';
    last.el.style.top = last.from.y + 'px';
  }
};

/* ---- Clear ---- */
document.getElementById('clear').onclick = function () {
  const confirmed = confirm('Are you sure you want to clear the board? This cannot be undone.');
  if (!confirmed) return;

  paths = [];
  redraw();
  document.querySelectorAll('.piece').forEach(p => p.remove());
};

/* ---- Clear Strokes Only ---- */
document.getElementById('clear-strokes').onclick = function () {
  const confirmed = confirm('Are you sure you want to clear all drawings? This cannot be undone.');
  if (!confirmed) return;

  paths = [];
  redraw();

  // ✅ RECORD CLEAR-STROKES EVENT
  if (isRecording) {
    recorded.push({ type: 'clear-strokes' });
  }
};

/* ---- Pieces ---- */
let lastPieceOffset = 0;

function createPiece(type, x = null, y = null, pid = null) {
  const p = document.createElement('div');
  p.dataset.pid = pid || crypto.randomUUID();
p.classList.add('piece', type);

const img = document.createElement('img');
img.src = type === 'x'
  ? 'https://cdn.shopify.com/s/files/1/0017/4175/0387/files/x.svg?v=1769467093'
  : 'https://cdn.shopify.com/s/files/1/0017/4175/0387/files/o.svg?v=1769467093';

img.draggable = false;
img.style.width = '100%';
img.style.height = '100%';
img.style.pointerEvents = 'none';

p.appendChild(img);
clipboard.appendChild(p);

  if (x === null || y === null) {
    x = 280 + (lastPieceOffset % 5) * 12;
    y = 180 + (lastPieceOffset % 5) * 12;
    lastPieceOffset++;
  }

  p.style.left = x + 'px';
  p.style.top = y + 'px';

  // --- SNAP BALL CLICK ONLY WHEN CLICKED DIRECTLY ---
p.addEventListener('click', e => {
  if (!snapMode) return;

  if (!snappedPiece) {
    snappedPiece = p;
    ballLocked = true; // 🔒 LOCK BALL

    ball.style.left = (p.offsetLeft + snapOffset.x) + 'px';
    ball.style.top = (p.offsetTop + snapOffset.y) + 'px';
    snapMessage.style.display = 'none';
  }
});

  let dragging = false;
  let startX, startY, fromX, fromY;
  let piecePath = []; // <-- keeps track of the piece's drag path while moving

  p.addEventListener('mousedown', e => {
    dragging = true;
    trash.classList.add('active');
    fromX = p.offsetLeft;
    fromY = p.offsetTop;
    startX = e.clientX - fromX;
    startY = e.clientY - fromY;
  });

// --- TOUCH SUPPORT FOR DRAGGING PIECES ---
p.addEventListener('touchstart', e => {
  e.preventDefault();
  dragging = true;
  const touch = e.touches[0];
  fromX = p.offsetLeft;
  fromY = p.offsetTop;
  startX = touch.clientX - fromX;
  startY = touch.clientY - fromY;
});

p.addEventListener('touchmove', e => {
  if (!dragging) return;
  e.preventDefault();
  const touch = e.touches[0];
  const left = touch.clientX - startX;
  const top = touch.clientY - startY;

  p.style.left = left + 'px';
  p.style.top = top + 'px';

  // --- RECORD PATH IF RECORDING ---
  if (isRecording) {
    piecePath.push({ x: left, y: top });
  }

  // --- MOVE BALL ALONG WITH PIECE ---
  if (snappedPiece === p) {
    ball.style.left = (p.offsetLeft + snapOffset.x) + 'px';
    ball.style.top = (p.offsetTop + snapOffset.y) + 'px';
  }
});

document.addEventListener('mousemove', e => {
  if (!dragging) return;

  const left = e.clientX - startX;
const top = e.clientY - startY;

p.style.left = left + 'px';
p.style.top = top + 'px';

// --- RECORD PATH IF RECORDING ---
if (isRecording) {
  piecePath.push({ x: left, y: top });
}

// --- MOVE BALL ALONG WITH PIECE ---
if (snappedPiece === p) {
  ball.style.left = (p.offsetLeft + snapOffset.x) + 'px';
  ball.style.top = (p.offsetTop + snapOffset.y) + 'px';
}

  // --- MOVE BALL ONLY WITH THE PIECE THAT HAS THE BALL SNAPPED ---
if (snappedPiece === p) {
  ball.style.left = (p.offsetLeft + snapOffset.x) + 'px';
  ball.style.top = (p.offsetTop + snapOffset.y) + 'px';
}
});

  document.addEventListener('mouseup', () => {
    if (!dragging) return;
    dragging = false;
    trash.classList.remove('active');

    history.push({
      type: 'move',
      el: p,
      from: { x: fromX, y: fromY }
    });

    const pieceRect = p.getBoundingClientRect();
const trashRect = trash.getBoundingClientRect();
if (
  pieceRect.right > trashRect.left &&
  pieceRect.left < trashRect.right &&
  pieceRect.bottom > trashRect.top &&
  pieceRect.top < trashRect.bottom
) {
  p.remove();

  // If this piece had the ball snapped to it, free + unlock the ball
  if (snappedPiece === p) {
    snappedPiece = null;
    ballLocked = false; // 🔓 THIS IS THE FIX
  }
}

    if (isRecording && piecePath.length > 0) {
  recorded.push({
    type: 'move-path',
    pid: p.dataset.pid,
    path: [...piecePath],
    snappedBall: (snapMode && snappedPiece === p)
      ? piecePath.map(pt => ({ x: pt.x + snapOffset.x, y: pt.y + snapOffset.y }))
      : null
  });
}
piecePath = []; // reset for next drag
  });

  if (isRecording) recorded.push({ type: 'piece-add', pieceType: type, x, y });

  return p;
}

/* ---- Pass Ball ---- */
function initiatePass() {
  if (!snappedPiece) {
    alert('Ball must be snapped to a player to pass.');
    return;
  }

  const pieces = [...document.querySelectorAll('.piece')].filter(p => p !== snappedPiece);

  if (pieces.length === 0) {
    alert('You need another player to pass to.');
    return;
  }

  snapMessage.textContent = 'Select a player to pass to';
  snapMessage.style.display = 'block';

  function onSelect(target) {
    snapMessage.style.display = 'none';

    const from = { x: ball.offsetLeft, y: ball.offsetTop };
    const to = {
      x: target.offsetLeft + snapOffset.x,
      y: target.offsetTop + snapOffset.y
    };

    animateBallMove(from, to, () => {
      snappedPiece = target;
    });

    if (isRecording) {
      recorded.push({ type: 'pass', from, to });
    }

    cleanup();
  }

  function cleanup() {
    pieces.forEach(p => p.removeEventListener('click', handlerMap.get(p)));
    handlerMap.clear();
  }

  const handlerMap = new Map();

  pieces.forEach(p => {
    const handler = () => onSelect(p);
    handlerMap.set(p, handler);
    p.addEventListener('click', handler, { once: true });
  });
}

passBtn.onclick = initiatePass;

/* ---- Shoot Ball ---- */
function initiateShot() {
  if (!snappedPiece) {
    alert('Ball must be snapped to a player to shoot.');
    return;
  }

  const from = { x: ball.offsetLeft, y: ball.offsetTop };
  const to = { x: HOOP_TARGET.x, y: HOOP_TARGET.y };

  animateBallMove(from, to, () => {
  snappedPiece = null;
  snapMode = false;
  ballLocked = false; // 🔓 UNLOCK BALL AFTER SHOT

  // Turn off snap UI
  const snapBtn = document.getElementById('snap-ball');
  snapBtn.classList.remove('active');
  snapMessage.style.display = 'none';
});

  if (isRecording) {
    recorded.push({ type: 'shoot', from, to });
  }
}

shootBtn.onclick = initiateShot;

document.getElementById('add-x').onclick = () => {
  if (document.querySelectorAll('.piece.x').length >= 5) return;
  createPiece('x');
};
document.getElementById('add-o').onclick = () => {
  if (document.querySelectorAll('.piece.o').length >= 5) return;
  createPiece('o');
};

/* ---- Ball ---- */
let draggingBall = false;
let bx, by, ox, oy;

bx = ball.offsetLeft;
by = ball.offsetTop;

ball.addEventListener('mousedown', e => {
  if (ballLocked) return; // 🚫 BLOCK DRAG

  draggingBall = true;
  bx = ball.offsetLeft;
  by = ball.offsetTop;
  ox = e.clientX - bx;
  oy = e.clientY - by;
});

// --- TOUCH SUPPORT FOR DRAGGING BALL ---
ball.addEventListener('touchstart', e => {
  if (ballLocked) return; // 🚫 BLOCK DRAG

  e.preventDefault();
  draggingBall = true;
  const touch = e.touches[0];
  bx = ball.offsetLeft;
  by = ball.offsetTop;
  ox = touch.clientX - bx;
  oy = touch.clientY - by;
});

document.addEventListener('mousemove', e => {
  if (!draggingBall) return;
  ball.style.left = (e.clientX - ox) + 'px';
  ball.style.top = (e.clientY - oy) + 'px';
});

document.addEventListener('mouseup', () => {
  if (draggingBall) {
    history.push({ type: 'move', el: ball, from: { x: bx, y: by } });

    if (isRecording) {
      recorded.push({
        type: 'move',
        elType: 'ball',
        from: { x: bx, y: by },
        to: { x: ball.offsetLeft, y: ball.offsetTop }
      });
    }
  }
  draggingBall = false;
});

/* ---- Ball toggle ---- */
document.getElementById('toggle-ball').onclick = () => {
  ball.style.display = ball.style.display === 'none' ? 'block' : 'none';
};

/* ---- Recording ---- */
recordBtn.onclick = function () {
  isRecording = !isRecording;
  recordBtn.classList.toggle('recording', isRecording);
  if (isRecording) {
    recorded = [];
    recordedPiecesSnapshot = [...document.querySelectorAll('.piece')].map(p => ({
  type: p.classList.contains('x') ? 'x' : 'o',
  x: p.offsetLeft,
  y: p.offsetTop,
  pid: p.dataset.pid,
  ballOffset: snapMode && snappedPiece === p
    ? { x: ball.offsetLeft - p.offsetLeft, y: ball.offsetTop - p.offsetTop }
    : null
}));
  }
};

document.getElementById('snap-ball').onclick = () => {
  const pieces = document.querySelectorAll('.piece');

  if (!snapMode && pieces.length === 0) {
    alert('Must add players to board in order to use this tool.');
    return;
  }

  snapMode = !snapMode;

// If turning snap mode OFF, fully release the ball
if (!snapMode) {
  snappedPiece = null;
  ballLocked = false; // 🔓 AUTO-UNLOCK BALL
}
  document.getElementById('snap-ball').classList.toggle('active', snapMode);
  snapMessage.style.display = snapMode ? 'block' : 'none';
};

/* ---- Playback ---- */
document.getElementById('play').onclick = function () {
    // If playback already finished, restart from beginning
if (playbackIndex >= recorded.length) {
  playbackIndex = 0;
}
    isPlayingBack = true;
    playbackToken++;
const myToken = playbackToken;
  if (playbackIndex === 0) {

    // 🔥 HARD RESET — REQUIRED
  snappedPiece = null;
  snapMode = false;
  ballLocked = false;
  draggingBall = false;

  // 🔥 CLEAR ANY RECORDING-LEFTOVER FLAGS
  isRecording = false;

  // 🔥 RESET BALL TO BASELINE
  ball.style.transition = 'none';

  // 🔥 RESET PIECE STATE BEFORE REMOVAL
  document.querySelectorAll('.piece').forEach(p => {
    p._piecePath = [];
  });

  paths = [];
  redraw();
  document.querySelectorAll('.piece').forEach(p => p.remove());

  ball.style.display = 'block';
  ball.style.left = bx + 'px';
  ball.style.top = by + 'px';

  recordedPiecesSnapshot.forEach(p => {
    const pieceEl = createPiece(p.type, p.x, p.y, p.pid);

    if (p.ballOffset) {
      snappedPiece = pieceEl;
      ball.style.left = (p.x + p.ballOffset.x) + 'px';
      ball.style.top = (p.y + p.ballOffset.y) + 'px';
    }
  });
}

  function next() {
  if (myToken !== playbackToken) return;
  if (!isPlayingBack) return;
  if (playbackIndex >= recorded.length) {
  isPlayingBack = false;
  ballLocked = false; // 🔓 FINAL SAFETY UNLOCK
  return;
}

   const e = recorded[playbackIndex];

    /* ---- STROKE ---- */
    if (e.type === 'stroke') {
      const animatedPath = {
        color: e.path.color,
        size: e.path.size,
        erase: e.path.erase,
        points: []
      };

      paths.push(animatedPath);

      let j = 0;
      function drawPoint() {
        if (myToken !== playbackToken) return;
        if (j >= e.path.points.length) {
          playbackIndex++;
          next();
          return;
        }
        animatedPath.points.push(e.path.points[j]);
        redraw();
        j++;
        setTimeout(drawPoint, 15);
      }

      drawPoint();
      return;
    }

/* ---- CLEAR STROKES ---- */
if (e.type === 'clear-strokes') {
  paths = [];
  redraw();
  playbackIndex++;
  next();
  return;
}

    /* ---- MOVE ---- */
    if (e.type === 'move') {
      let targetEl;

      if (e.elType === 'ball') {
        targetEl = ball;
      } else {
        targetEl = [...document.querySelectorAll('.piece')].find(p => {
          const type = p.classList.contains('x') ? 'x' : 'o';
          return (
            type === e.elType &&
            Math.abs(p.offsetLeft - e.from.x) < 2 &&
            Math.abs(p.offsetTop - e.from.y) < 2
          );
        });
      }

      if (!targetEl) {
        playbackIndex++;
        next();
        return;
      }

      const steps = 10;
      let step = 0;
      const dx = (e.to.x - e.from.x) / steps;
      const dy = (e.to.y - e.from.y) / steps;

      function animateMove() {
        if (myToken !== playbackToken) return;
  if (step >= steps) {
    targetEl.style.left = e.to.x + 'px';
    targetEl.style.top = e.to.y + 'px';

 if (e.snappedBall && e.snappedBall.length) {
  const last = e.snappedBall[e.snappedBall.length - 1];
  ball.style.left = last.x + 'px';
  ball.style.top  = last.y + 'px';
}
    playbackIndex++;
    next();
    return;
  }

  targetEl.style.left = (e.from.x + dx * step) + 'px';
  targetEl.style.top = (e.from.y + dy * step) + 'px';

  // Move ball along with piece step by step
if (e.snappedBall && e.snappedBall[step]) {
  ball.style.left = e.snappedBall[step].x + 'px';
  ball.style.top  = e.snappedBall[step].y + 'px';
}

  step++;
  setTimeout(animateMove, 30);
}

      animateMove();
      return;
    }

    /* ---- MOVE-PATH ---- */
if (e.type === 'move-path') {
  const targetEl = document.querySelector(
  `.piece[data-pid="${e.pid}"]`
);

  if (!targetEl) { playbackIndex++; next(); return; }

  let j = 0;
  function animatePiecePath() {
    if (myToken !== playbackToken) return;
    if (j >= e.path.length) { playbackIndex++; next(); return; }

    targetEl.style.left = e.path[j].x + 'px';
    targetEl.style.top = e.path[j].y + 'px';

    // Move ball if it was snapped
    if (e.snappedBall && e.snappedBall[j]) {
  ball.style.left = e.snappedBall[j].x + 'px';
  ball.style.top  = e.snappedBall[j].y + 'px';
}

    j++;
    setTimeout(animatePiecePath, 20); // adjust speed here
  }
  animatePiecePath();
  return;
}

/* ---- PASS ---- */
if (e.type === 'pass') {
  animateBallMove(e.from, e.to, () => {
  if (myToken !== playbackToken) return;
    // Snap to closest piece at destination
    snappedPiece = [...document.querySelectorAll('.piece')].find(p =>
      Math.abs(p.offsetLeft + snapOffset.x - e.to.x) < 5 &&
      Math.abs(p.offsetTop + snapOffset.y - e.to.y) < 5
    ) || null;

    playbackIndex++;
    next();
  });
  return;
}

/* ---- SHOOT ---- */
if (e.type === 'shoot') {
  animateBallMove(e.from, e.to, () => {
  if (myToken !== playbackToken) return;
    snappedPiece = null;
    ballLocked = false; // 🔓 UNLOCK AFTER SHOT PLAYBACK
    playbackIndex++;
    next();
  });
  return;
}

    /* ---- PIECE ADD ---- */
    if (e.type === 'piece-add') {
      createPiece(e.pieceType, e.x, e.y);
    }

    playbackIndex++;
    setTimeout(next, 20);
  }

  next();
};

/* ---- PLAY typing easter egg ---- */
let playSequence = '';
const PLAY_CODE = 'PLAY';

document.addEventListener('keydown', e => {
  // Ignore typing inside inputs/textareas
  if (
    document.activeElement &&
    (document.activeElement.tagName === 'INPUT' ||
     document.activeElement.tagName === 'TEXTAREA')
  ) {
    return;
  }

  playSequence += e.key.toUpperCase();

  // Keep only last 4 characters
  if (playSequence.length > 4) {
    playSequence = playSequence.slice(-4);
  }

  if (playSequence === PLAY_CODE) {
    window.location.href = '/playdraawer.html'; // same page as footer long-press
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const helpBtn = document.getElementById('help-button');
  const overlay = document.getElementById('help-overlay');
  const closeBtn = document.getElementById('help-close');

  if (!helpBtn || !overlay || !closeBtn) return;

  helpBtn.addEventListener('click', () => {
    overlay.classList.add('open');
  });

  closeBtn.addEventListener('click', () => {
    overlay.classList.remove('open');
  });

  overlay.addEventListener('click', e => {
    if (e.target === overlay) {
      overlay.classList.remove('open');
    }
  });
});

/* ============================= */
/* Keyboard Shortcuts Controller */
/* ============================= */

(function () {

  // Prevent shortcuts while typing
  function isTypingTarget(e) {
    const tag = e.target.tagName.toLowerCase();
    return tag === 'input' || tag === 'textarea' || e.target.isContentEditable;
  }

  document.addEventListener('keydown', (e) => {
    // Prevent Space / Esc default browser behavior
if (e.code === 'Space' || e.key === 'Escape') {
  e.preventDefault();
}
    if (isTypingTarget(e)) return;

    const key = e.key.toLowerCase();

    switch (key) {

      /* -------- Pieces -------- */
      case 'o':
        document.getElementById('add-o')?.click();
        break;

      case 'x':
        document.getElementById('add-x')?.click();
        break;

      /* -------- Drawing Tools -------- */
      case 'b': // Blue pen
        document.getElementById('blue-pen')?.click();
        break;

      case 'r': // Red pen
        document.getElementById('red-pen')?.click();
        break;

      case 'e': // Eraser
        document.getElementById('eraser')?.click();
        break;

      /* -------- Recording / Playback -------- */
      case 'v': // Record toggle
        document.getElementById('record')?.click();
        break;

      case ' ': // Play (only)
        document.getElementById('play')?.click();
        break;

      case 'escape': // Stop (only)
        document.getElementById('stop')?.click();
        break;

      /* -------- Utility -------- */
      case 'u': // Undo
        document.getElementById('undo')?.click();
        break;

      case 'c': // Clear entire board
  document.getElementById('clear')?.click();
  break;

case 'k': // Clear strokes only
  document.getElementById('clear-strokes')?.click();
  break;

      /* -------- Ball -------- */
      case 't': // Toggle ball
        document.getElementById('toggle-ball')?.click();
        break;

        case 'p': // Pass
  document.getElementById('pass-ball')?.click();
  break;

case 's': // Shoot
  document.getElementById('shoot-ball')?.click();
  break;

      case 'm': // Snap ball
        document.getElementById('snap-ball')?.click();
        break;
    }
  });

})();

/* ---- Stop Playback ---- */
document.getElementById('stop').onclick = () => {
  isPlayingBack = false;
};
